import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { initialThemeState } from 'src/app/modules/redux';
import { Theme } from 'src/app/modules/redux/stores/theme/theme.model';
import { UtilService } from 'src/app/modules/shared/services';

@Component({
  selector: 'app-markeing-navigation',
  templateUrl: './marketing-navigation.component.html',
  styleUrls: ['./markeing-navigation.component.scss']
})
export class MarketingNavigationComponent implements OnInit {
  background: ThemePalette = undefined;
  theme: Theme = initialThemeState;
  constructor(
    public util: UtilService,
  ) {  }


  ngOnInit(): void {
  }

}
